import { render, staticRenderFns } from "./MethodPreview.vue?vue&type=template&id=72c41a00&scoped=true&"
import script from "./MethodPreview.vue?vue&type=script&lang=js&"
export * from "./MethodPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c41a00",
  null
  
)

export default component.exports